import type { FC, ReactElement } from 'react';
import { useEffect } from 'react';

import { useRedirectToLobbyCallbackConnected } from '../../../hooks/useRedirectToLobbyCallbackConnected';
import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { usePopupSlice } from '../../../store/slices/popup/selectors';
import { popupActions } from '../../../store/slices/popup/slice';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalContent } from './BlockingModalContent';

export const PrivateTableOccupiedConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const redirectToLobby = useRedirectToLobbyCallbackConnected();
  const currentPopupData = usePopupSlice.currentPopupData();
  const isPopUpVisible = Boolean(currentPopupData?.popUpInGame);

  useEffect(() => {
    if (isPopUpVisible) {
      const timeoutId = setTimeout(() => {
        redirectToLobby();
      }, 3000); // existing functionality where user needs to be redirected to lobby after 3 sec showing popup

      return (): void => clearTimeout(timeoutId);
    }
  }, [isPopUpVisible]);

  const action = [
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        if (isPopUpVisible) {
          redirectToLobby();
        } else {
          dispatch(popupActions.dismissPopup(PopupType.PrivateTableOccupied));
        }
      }}
    />,
  ];

  return (
    <BlockingModalContent title={<L10nText tk="TABLE_OCCUPIED" />} actions={action}>
      <L10nText tk="PRIVATE_OCCUPIED" />
    </BlockingModalContent>
  );
};
